class Countdown extends HTMLElement {
    connectedCallback() {
        this.dateEnd = this.getAttribute('data-end-time');
        this.dateServer = this.getAttribute('data-server-time');
        this.useServerTime = this.getAttribute('data-use-server-time');
        this.showSectionTime = this.getAttribute('data-show-section-time'); // NEW
        this.init(this);
    }

    addSeconds(date, seconds) {
        date.setSeconds(date.getSeconds() + seconds);
        return date;
    }

    // NEW: parse common date strings robustly (e.g., "YYYY/MM/DD HH:mm:ss")
    parseDate(val) {
        if (!val) return NaN;
        if (val instanceof Date) return val;
        if (typeof val !== 'string') return new Date(val);
        if (val.trim() === 'false') return NaN;

        let s = val.trim();
        // turn "2025/08/29 20:07:07" into "2025-08-29T20:07:07"
        if (/^\d{4}[\/-]\d{1,2}[\/-]\d{1,2}/.test(s) && !s.includes('T')) {
            s = s.replace(/\//g, '-').replace(' ', 'T');
        }
        let d = new Date(s);
        if (!isNaN(d)) return d;

        // fallback manual construct
        const m = s.match(/^(\d{4})[\/-](\d{1,2})[\/-](\d{1,2})[ T](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?$/);
        if (m) {
            const [_, y, mo, da, h, mi, se] = m;
            return new Date(+y, +mo - 1, +da, +h, +mi, +(se || 0));
        }
        return NaN;
    }

    // NEW: should we hide until the show time?
    shouldHideUntilShowTime(nowDate) {
        const raw = this.showSectionTime;
        if (!raw || raw === 'false') return false;
        const showTime = this.parseDate(raw);
        if (!(showTime instanceof Date) || isNaN(showTime)) return false;
        return nowDate < showTime;
    }

    init(_this, timeGap = 0) {
        // ===== NOW (two logics) =====
        let nowDate = new Date(); // user time
        if (this.useServerTime === 'true') {
            nowDate = this.parseDate(_this.dateServer); // server time seed
            if (!(nowDate instanceof Date) || isNaN(nowDate)) nowDate = new Date(); // fallback
            if (timeGap >= 0) { // tick forward each second
                nowDate = this.addSeconds(nowDate, timeGap);
                timeGap += 1;
            }
        }

        // ===== GATE BY data-show-section-time =====
        const countdownEl = _this.querySelector(".countdown");
        if (this.shouldHideUntilShowTime(nowDate)) {
            countdownEl?.classList.add("hidden-i");
            setTimeout(() => { _this.init(_this, timeGap); }, 1000);
            return;
        } else {
            countdownEl?.classList.remove("hidden-i");
        }

        // ===== COUNTDOWN CORE =====
        const achieveDate = this.parseDate(_this.getAttribute('data-end-time'));
        if (!(achieveDate instanceof Date) || isNaN(achieveDate)) {
            countdownEl?.classList.add("hidden-i");
            return;
        }
        const result = (achieveDate - nowDate) + 1000;

        if (result < 0) {
            countdownEl?.classList.add("hidden-i");
            return;
        }

        const resultSeconds = Math.floor((result / 1000) % 60);
        const resultMinutes = Math.floor((result / 1000 / 60) % 60);
        const resultHours   = Math.floor((result / 1000 / 60 / 60) % 24);
        const resultDays    = Math.floor(result / 1000 / 60 / 60 / 24);

        // ===== SETTINGS =====
        const daysBlock = _this.querySelector('[data-id="days"]')?.closest(".countdown__item");
        const _hideDaysWhenZero = _this.getAttribute('data-hide-days-when-zero') === 'true';
        const _useTotalHours    = _this.getAttribute('data-use-total-hours') === 'true';

        // ===== HANDLE DAYS BLOCK =====
        if (daysBlock) {
            if (_useTotalHours) {
                daysBlock.classList.add('hidden-i');
            } else if (_hideDaysWhenZero) {
                if (resultDays === 0) daysBlock.classList.add('hidden-i');
                else daysBlock.classList.remove('hidden-i');
            } else {
                daysBlock.classList.remove('hidden-i');
            }
        }

        // ===== DISPLAY VALUES =====
        if (_useTotalHours) {
            const totalHours = Math.floor(result / 1000 / 60 / 60);
            _this.querySelector("[data-id='hours']").innerHTML = totalHours < 10 ? "0" + totalHours : totalHours;
        } else {
            _this.querySelector("[data-id='days']").innerHTML = resultDays < 10 ? "0" + resultDays : resultDays;
            _this.querySelector("[data-id='hours']").innerHTML = ("0" + resultHours).slice(-2);
        }

        _this.querySelector("[data-id='minutes']").innerHTML = ("0" + resultMinutes).slice(-2);
        _this.querySelector("[data-id='seconds']").innerHTML = ("0" + resultSeconds).slice(-2);

        setTimeout(() => { _this.init(_this, timeGap); }, 1000);
    }
}
customElements.define('countdown-timer', Countdown);
